import $ from 'jquery';

export default (id) => {

    $(document).ready(function () {

        $('.nav-link').click(function (e) {
            location.hash = $(this).attr('href');
        });

        let anchor = window.location.hash;

        anchor = anchor.split('#')[1];

        if (anchor !== undefined) {
            $(".nav-link").removeClass("active").removeClass("show");
            $(".tab-pane").removeClass("active").removeClass("show");

            $('a[href$="#' + anchor + '"]').addClass('active').addClass('show');
            $('#' + anchor).addClass('active').addClass('show');
        } else {


            if (id) {
                $('a[href$="#' + id + '"]').addClass('active').addClass('show');
                $('#' + id).addClass('active').addClass('show');
            } else {
                $(".nav-link").first().addClass("active").addClass('show');
                $(".tab-pane").first().addClass("active").addClass('show');
            }

        }

    });


};

